import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Link} from 'react-router-dom'
const QuoteGenerator = () => {
  const [quote, setQuote] = useState({ author: '', text: '' });

  useEffect(() => {
    fetchQuote();
  }, []);

  const fetchQuote = () => {
    fetch('https://api.quotable.io/random')
      .then(response => response.json())
      .then(data => setQuote({ author: data.author, text: data.content }));
  };

  return (
    <div className='App'>
      <nav aria-label="breadcrumb" className='mt-2'>
  <ol className="breadcrumb text-dark ">
    <li className="breadcrumb-item "><Link to="/">Home</Link></li>
    <li className="breadcrumb-item active" aria-current="page">DDAI Quote Generator</li>
  </ol>
</nav>
   
    <div className="container mt-5">
      <div className="card">
        <img src="https://source.unsplash.com/random/800x600" style={{ width: "600px", height:"400px", margin:"auto"}} className="card-img-top" alt="..." />
        <div className="card-body">
          <blockquote className="blockquote mb-0">
            <p id="text">{quote.text}</p>
            <footer className="blockquote-footer" id="author">{quote.author}</footer>
          </blockquote>
        </div>
      </div>
      <div className="text-center mt-5">
        <button className="btn btn-warning" onClick={fetchQuote}>Get Another Quote</button>
      </div>
    </div>
    </div>
  );
};

export default QuoteGenerator;
